/**
 * @generated SignedSource<<6ea5469fab9e9c1bd67b44c5323a81b4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type usePrintTypeInfoQuery$variables = Record<PropertyKey, never>;
export type usePrintTypeInfoQuery$data = {
  readonly hasPalettePantoneCMYK: boolean;
};
export type usePrintTypeInfoQuery = {
  response: usePrintTypeInfoQuery$data;
  variables: usePrintTypeInfoQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "hasPalettePantoneCMYK",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "usePrintTypeInfoQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "usePrintTypeInfoQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "f1ca3005d8ae7b9b38c7e885f3f9d84b",
    "id": null,
    "metadata": {},
    "name": "usePrintTypeInfoQuery",
    "operationKind": "query",
    "text": "query usePrintTypeInfoQuery {\n  hasPalettePantoneCMYK\n}\n"
  }
};
})();

(node as any).hash = "5e7ba457c52ccbc3c2e865178f3b8bc4";

export default node;
